// import {useState, useEffect, useRef} from "react";
import SectionTitle from "../../components/SectionTitles/SectionTitle";
// import SectionTitleTwo from "../../components/SectionTitles/SectionTitleTwo";
// import Tilt from 'react-parallax-tilt';
// import Parallax from 'parallax-js';
// import {Link} from "react-router-dom";

const UnderConstruction = () => {
  return (
    <div className="section section-padding-t90 section-padding-bottom-200">
      <div className="container">
        <SectionTitle
          title="信息待公布"
          // subTitle="Our team of designers, developers and creatives are perfectionists
          // who love what they do and love"
        />

        <div className="row">
        {/* <embed src="/images/underconstruction/under.svg"></embed> */}
        </div>
          
      </div>
    </div>
  );
};

export default UnderConstruction;
